import React from 'react';
import Button from '@atlaskit/button';
import { useIntl } from '@atlassian/jira-intl';
import { useUnarchiveIssueModalActions } from '@atlassian/jira-unarchive-modal/src/controllers/main.tsx';
import { useArchiveIssueActions } from '../../../controllers/main.tsx';
import {
	useArchiveIssueStates,
	getAllSelectedIssuesWithDetails,
} from '../../../controllers/selectors.tsx';
import { messages } from './messages.tsx';

const UnarchiveIssues = () => {
	const { formatMessage } = useIntl();
	const state = useArchiveIssueStates();

	const allSelectedIssuesWithDetails = getAllSelectedIssuesWithDetails({ state });
	const { openUnarchiveIssuesModal } = useUnarchiveIssueModalActions();
	const { clearAllSelections, setRefetchArchivesIssuesData } = useArchiveIssueActions();

	const onClick = () => {
		openUnarchiveIssuesModal({
			selectedIssuesDetails: allSelectedIssuesWithDetails,
			onSuccessCallback: () => {
				clearAllSelections();
				setRefetchArchivesIssuesData(true);
			},
			showViewIssueActionInSuccessFlag: true,
		});
	};

	return (
		<Button
			id="issue-archival-archives.manage-bars.unarchive-issues.button"
			appearance="subtle"
			onClick={onClick}
		>
			{formatMessage(messages.buttonLabel)}
		</Button>
	);
};

export default UnarchiveIssues;
